<template>
  <rh-etapa-card
    titulo="Anexos e Documentação"
    subtitulo="Todos os arquivos do colaborador, agrupados pela etapa em que foram enviados"
    icone="mdi-file-document-multiple-outline"
  >
    <template #acoes>
      <v-btn
        color="success"
        outlined
        small
        class="rounded-lg"
        :disabled="!form.pessoal.rh_id"
        @click="gerarRelatorioDossie"
      >
        <v-icon left>mdi-file-chart-outline</v-icon> Gerar Dossiê Completo
      </v-btn>
    </template>

    <v-row class="mb-2">
      <v-col
        v-for="categoria in resumoCategorias"
        :key="categoria.id"
        cols="6"
        sm="4"
        md="2"
        class="pa-1"
      >
        <div class="rh-resumo-categoria pa-3 rounded-lg" :class="{ 'is-vazio': !categoria.total }">
          <v-icon :color="categoria.total ? 'primary' : 'grey'" small>{{ categoria.icone }}</v-icon>
          <div class="text-h6 font-weight-bold mt-1">{{ categoria.total }}</div>
          <div class="text-caption grey--text rh-resumo-categoria__titulo">
            {{ categoria.titulo }}
          </div>
        </div>
      </v-col>
    </v-row>

    <v-alert v-if="pendentes > 0" dense text type="info" class="mb-4">
      {{ pendentes }} {{ pendentes === 1 ? "arquivo será enviado" : "arquivos serão enviados" }}
      ao salvar. O Dossiê inclui apenas documentos já salvos.
    </v-alert>

    <rh-documentos-uploader
      titulo="Adicionar outros documentos"
      subtitulo="Arquivos que não pertencem a nenhuma etapa anterior. Somente PDF, até 2MB."
      categoria="geral"
      :itens="documentos"
      mostrar-categoria
      @adicionar="$emit('adicionar-documentos', $event)"
      @remover="$emit('remover-documento', $event)"
      @baixar="$emit('baixar-documento', $event)"
    />
  </rh-etapa-card>
</template>

<script>
import RhEtapaCard from "../components/RhEtapaCard.vue";
import RhDocumentosUploader from "../components/RhDocumentosUploader.vue";
import { CATEGORIAS_DOCUMENTO } from "../config/rhConfig";

export default {
  name: "EtapaAnexos",
  components: { RhEtapaCard, RhDocumentosUploader },
  props: {
    form: { type: Object, required: true },
    documentos: { type: Array, default: () => [] },
  },
  computed: {
    resumoCategorias() {
      return CATEGORIAS_DOCUMENTO.map((categoria) => ({
        ...categoria,
        total: this.documentos.filter((d) => d.categoria === categoria.id).length,
      }));
    },
    pendentes() {
      return this.documentos.filter((d) => d.novo).length;
    },
  },
  methods: {
    async gerarRelatorioDossie() {
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.recursosHumanosService.gerarRelatorioDossie(
          parseInt(this.form.pessoal.user_id, 10),
          parseInt(this.form.pessoal.rh_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style scoped>
.rh-resumo-categoria {
  background: var(--surface-2);
  border: 1px solid var(--border);
  height: 100%;
}

.rh-resumo-categoria__titulo {
  line-height: 1.3;
}

.rh-resumo-categoria.is-vazio {
  opacity: 0.6;
}
</style>
